import apiClient from './api';

export interface Inquiry {
  id: number;
  title: string;
  content: string;
  status: string;
  answer?: string | null;
  createdAt: string;
  answeredAt?: string | null;
}

export interface InquiryCreateRequest {
  title: string;
  content: string;
}

export const inquiryService = {
  getMyInquiries: async (): Promise<Inquiry[]> => {
    const response = await apiClient.get<Inquiry[]>('/me/inquiries');
    return response.data;
  },

  getInquiries: async (page: number = 0, size: number = 10): Promise<Inquiry[]> => {
    const response = await apiClient.get<Inquiry[]>('/inquiries', {
      params: { page, size }
    });
    return response.data;
  },

  getInquiry: async (id: number): Promise<Inquiry> => {
    const response = await apiClient.get<Inquiry>(`/inquiries/${id}`);
    return response.data;
  },

  createInquiry: async (data: InquiryCreateRequest): Promise<Inquiry> => {
    const response = await apiClient.post<Inquiry>('/inquiries', data);
    return response.data;
  },

  deleteInquiry: async (id: number): Promise<void> => {
    await apiClient.delete(`/inquiries/${id}`);
  },
};
